import styled from "styled-components"
import theme from "../../theme"

export const LegalLayout = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`

export const LegalHeadline = styled.h1`
  font-size: 2rem;
  background-image:linear-gradient(90deg,${theme.brand.default},${theme.brand.alt},${theme.brand.default});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -.015em;
`

export const LegalContainer = styled.section`
  display: flex;
  flex-direction: column;
  flex: 10 100%;
  margin: 100px 0;
  max-width: 1024px;
  padding: 16px;
  color: ${theme.text.default};
  line-height: 1.47059;
  font-weight: 400;
  letter-spacing: -.022em;
  min-height: 56vh;

  @media (min-width: 1024px) {
    width: 100%;
  }

  & > h1,h2,h3,h4,h5,h6 {
    background-image:linear-gradient(90deg,${theme.brand.default},${theme.brand.alt},${theme.brand.default});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -.015em;
 }
`
